import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-start-free-courses',
  templateUrl: './start-free-courses.component.html',
  styleUrls: ['./start-free-courses.component.scss']
})
export class StartFreeCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
